import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { usePageName } from '@/context/PageNameProvider';
import { useAnalytics } from '@/hooks/analytics';
import { useUserState } from '@/hooks/store';
import { getUserIdForAnalytics } from '@/utils/getUserIdForAnalytics';

export default function PageViewedLogger() {
	const pageName = usePageName();
	const { logEvent } = useAnalytics();
	const searchParams = useSearchParams();
	const user = useUserState();

	const calmUserId = getUserIdForAnalytics(user, searchParams);

	// log page viewed on load
	useEffect(() => {
		if (!pageName) return;

		logEvent({
			eventName: 'Page : Viewed',
			eventProps: {
				page_name: pageName,
				calm_user_id: calmUserId || null,
			},
		});
	}, [logEvent, pageName, calmUserId]);

	return null;
}
